module.exports = __webpack_public_path__ + "static/media/dp2.9c64a270.jpg";